import React, { type ReactNode } from 'react';
import isEqual from 'lodash/isEqual';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createContainer, createHook, createStore } from '@atlassian/react-sweet-state';
import type { Store, Props } from './types.tsx';
import { getASTAndClausesFromJQL } from './utils.tsx';

type Actions = {};
const actions = Object.freeze<Actions>({});

const ASTContainerInternal = createContainer<Props>();

const store = createStore<Store, Actions, Props>({
	containedBy: ASTContainerInternal,
	initialState: {
		ast: {
			query: undefined,
			represents: '',
			errors: [],
		},
		clauseMap: {},
		textSearchInputClause: undefined,
	},
	actions,
	name: 'JQLBasic-ASTService',
	handlers: {
		onInit:
			() =>
			({ setState }, props) => {
				setState(getASTAndClausesFromJQL(props));
			},

		onContainerUpdate:
			(nextProps, prevProps) =>
			({ setState }) => {
				if (!isEqual(nextProps, prevProps)) {
					setState(getASTAndClausesFromJQL(nextProps));
				}
			},
	},
});

export type WrapperProps = {
	jql: string;
	onSwitchToJql?: () => void;
	children: ReactNode;
};

export const ASTContainer = ({
	jql,
	children,
	onSwitchToJql,
}: WrapperProps & {
	children: ReactNode;
}): React.JSX.Element => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<ASTContainerInternal
			jql={jql}
			createAnalyticsEvent={createAnalyticsEvent}
			onSwitchToJql={onSwitchToJql}
		>
			{children}
		</ASTContainerInternal>
	);
};

export const useAST = createHook(store, {
	selector: ({ ast }) => ast,
});

export const useClauseMap = createHook(store, {
	selector: ({ clauseMap }) => clauseMap,
});

/**
 * @deprecated use `useTextSearchInputClause` from '@atlassian/jira-jql-utils/src/utils/text-search-input-clause/use-text-search-input-clause.tsx' instead
 * delete useTextSearchInputClause when cleanup shplxi_628_cleanup fg
 */
export const useTextSearchInputClause = createHook(store, {
	selector: ({ textSearchInputClause }) => textSearchInputClause,
});
